/**
 * Gets an item from local storage unless it has expired
 * @param key the local storage key for the item
 * @returns the item from local storage or null
 */
export function getFromLocalStorage(key: string) {
  const localStorageKey = namespacedKey(key)
  const itemString = window.localStorage.getItem(localStorageKey)

  if (!itemString) {
    return null
  }

  const item = JSON.parse(itemString)
  const now = new Date()

  if (now.getTime() > item.expiry) {
    window.localStorage.removeItem(localStorageKey)
    return null
  }

  return item.value
}

/**
 * Removes an item from local storage
 * @param key the local storage key for the item
 * @returns null
 */
export function removeFromLocalStorage(key: string) {
  const localStorageKey = namespacedKey(key)
  window.localStorage.removeItem(localStorageKey)
}

/**
 * Sets an item in local storage that expires after a certain time
 * @param key the local storage key for the item
 * @param value the value to store under the key
 */
export function setLocalStorageWithExpiry(
  key: string,
  value: any,
  ttlSeconds: number
) {
  const localStorageKey = namespacedKey(key)
  const now = new Date()

  const item = {
    value: value,
    expiry: now.getTime() + ttlSeconds * 1000,
  }

  window.localStorage.setItem(localStorageKey, JSON.stringify(item))
}

/**
 * Returns a namespaced key, for our service, to prevent clashes
 * @param key the local storage key for the item
 */
export function namespacedKey(key: string): string {
  return "cultureampcom" + key
}
